import React from 'react';
import { useTranslation } from 'react-i18next';
import AppBar from '../components/AppBar/AppBar';
import { useThemeContext } from '../context/ThemeContext';
import styles from './MainLayout.module.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const { t } = useTranslation();
  const { isDark } = useThemeContext();

  return (
    <div
      className={styles.page}
      data-theme={isDark ? 'dark' : 'light'}
    >
      <AppBar />

      <div className={styles.separatorLine} aria-hidden="true" />

      <div className={styles.content}>{children}</div>

      <div className={styles.separatorLine} aria-hidden="true" />

      <footer className={styles.footer}>
        <div className={styles.container}>
          <p className={styles.footerCopyright}>{t('homePage.copyright')}</p>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout;
